import _http from './http';
import { getUrlParams } from '@/utils';
const isDev = process.env.NODE_ENV === 'development';
const devBaseUrl = '/mixServer';
const host = window.location.host;
const noLnDomainMix = `https://${host.replace('.', '2.')}`;
let currentUrl = getUrlParams('mix_url') ? 'https://' + getUrlParams('mix_url') : 'http://api.sdk.leniugame.com';
const prodBaseUrl = location.host === 'apisdk.lnqwe.com' ? 'https://apisdk2.lnqwe.com' : noLnDomainMix;
// const locationHost = `https://${location.host}`;
// let prodBaseUrl = locationHost.replace('.', '2.');

export const baseURL = isDev ? devBaseUrl : prodBaseUrl;

const http = _http.create({
  serverType: 'mix',
  baseURL
});

export const getConfig = params => {
  return http({
    url: '/api/config/get',
    method: 'post',
    params,
    // 不要处理成{mode:0,data:data}的格式
    noMode: true,
    // 不要增加time和access_token参数
    noTimeAndAccess: true,
    // 不要增加sign参数
    noSign: true,
    // 检查ret，不等于0抛出异常
    isInitCheck: true
  });
};

export const init = params => {
  return http({
    url: '/sdk/app/initialize',
    method: 'post',
    params,
    // 不要增加time和access_token参数
    noTimeAndAccess: true,
    // 不要增加sign参数
    noSign: true,
    // 检查ret，不等于0抛出异常
    isInitCheck: true
  });
};

// 登录
export const login = params => {
  return http({
    url: '/sdk/user/login',
    method: 'post',
    params
  });
};

// 融合同时下单（研发下单）
export const pay = params => {
  return http({
    url: '/sdk/pay/request',
    method: 'post',
    params
  });
};

// 角色上报
export const role = params => {
  return http({
    url: '/sdk/role/collect',
    method: 'post',
    params
  });
};

// 在线时长
export const online = params => {
  return http({
    url: '/sdk/user/online',
    method: 'post',
    params
  });
};

// 是否开启红包
export const openRebate = params => {
  return http({
    url: '/sdk/app/getRebateActV2',
    method: 'post',
    params
  });
};

// sdk登录拉起之前的红包
export const openPreRebate = params => {
  return http({
    url: '/sdk/app/getRebatePreview',
    method: 'post',
    params
  });
};

// ios苹果支付后发货
export const sendGoods = params => {
  return http({
    url: '/sdk/ios/receipt',
    method: 'post',
    params
  });
};

// 拍脸图弹窗
export const pushPopImg = params => {
  return http({
    url: '/sdk/popup/sdkPushPopup',
    method: 'post',
    params
  });
};
// 拍脸图弹窗上报
export const pushPopReport = params => {
  return http({
    url: '/sdk/popup/recordBehavior',
    method: 'post',
    params
  });
};
// 订单支付状态轮询
export const getOrderPayStatus = params => {
  return http({
    url: '/sdk/pay/getOrderPayStatus',
    method: 'post',
    params
  })
}
